import React from "react";
import TopBar from "../dashboard/TopBar";

const AdminNavbar = ({ toggleSidebar }) => (
  <TopBar toggleSidebar={toggleSidebar} />
);

export default AdminNavbar;
